import axios, { AxiosPromise } from 'axios';
import config from '@/config';
import { urlParamBuilder } from '@/helpers/urlParamBuilder';
import { Location } from '@/modules/nomenclature/models/location';

const resourceEndpoint = `${config.api.url}${config.api.privateEndpointsPrefix}${config.api.endpoints.nomenclature}`;

export function fetchAll(): AxiosPromise<Location[]> {
  return axios.get(`${resourceEndpoint}/locations/all`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function fetchChildren(location: Location): AxiosPromise<Location[]> {
  return axios.get(`${resourceEndpoint}/locations/${location.id}/children`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function fetchById(locationId: string): AxiosPromise<Location> {
  return axios.get(`${resourceEndpoint}/locations/${locationId}`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}

export function create(location: Location): AxiosPromise<Location> {
  return axios.post(
    `${resourceEndpoint}/locations/`,
    { location: location },
    {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  );
}

export function update(location: Location): AxiosPromise<Location> {
  return axios.put(
    `${resourceEndpoint}/locations/${location.id}`,
    { location: location },
    {
      withCredentials: true,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }
  );
}

export function destroy(locationId: string, param?: { onDeleteCascade?: boolean }): AxiosPromise<void> {
  const urlParam = urlParamBuilder(param);

  return axios.delete(`${resourceEndpoint}/locations/${locationId}?${urlParam}`, {
    withCredentials: true,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }
  });
}
